import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "../memberAsMember";

export const useMutationMembershipRevokeCancellationByMembershipIdAsMember = ({
  api,
  opts,
  onError,
  onSuccess,
}: {
  api: ApiType;
  opts: Parameters<
    ApiType["customerMembershipApi"]["membershipRevokeCancellationByMembershipId"]
  >[0];
  onSuccess?: UseMutationOptions<unknown, unknown, void>["onSuccess"];
  onError?: UseMutationOptions<unknown, unknown, void>["onError"];
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      api.customerMembershipApi.membershipRevokeCancellationByMembershipId(
        opts,
      ),
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.getCurrentMembershipSubscription(),
      });

      onSuccess?.(data, variables, context);
    },
    onError,
  });
};
